export interface TaskInstruction {
  id: RandomItemGenerationSubTask;
  instructions: string;
}

export const taskInstructions: TaskInstruction[] = [
  {
    id: 'task1',
    instructions:
      'Say as many letters or numbers (0-9) as you can. You are allowed to repeat items. Your goal is to list as many as possible in a random order.'
  },
  {
    id: 'task2',
    instructions:
      'Say as many items from the following category as you can. Do not repeat any item. Your goal is to list as many as possible.'
  }
];

export type RandomItemGenerationSubTask = 'task1' | 'task2';

export enum RandomItemGenerationCategory {
  None = 'none',
  Numbers = 'numbers',
  Letters = 'letters',
  FirstNames = 'firstNames',
  CityNames = 'cityNames',
  CountryNames = 'countryNames',
  Jobs = 'jobs',
  Fruits = 'fruits',
  Drinks = 'drinks',
  Animals = 'animals',
  WordStartingWithT = 'wordStartingWithT'
}

export const RandomItemGenerationSubTaskCategories: Record<RandomItemGenerationSubTask, RandomItemGenerationCategory[]> = {
  task1: [
    RandomItemGenerationCategory.Numbers,
    RandomItemGenerationCategory.Letters
  ],
  task2: [
    RandomItemGenerationCategory.FirstNames,
    RandomItemGenerationCategory.CityNames,
    RandomItemGenerationCategory.CountryNames,
    RandomItemGenerationCategory.Jobs,
    RandomItemGenerationCategory.Fruits,
    RandomItemGenerationCategory.Drinks,
    RandomItemGenerationCategory.Animals,
    RandomItemGenerationCategory.WordStartingWithT
  ]
};

export const RandomItemGenerationCategoryDescriptions: Record<RandomItemGenerationCategory, string> = {
  [RandomItemGenerationCategory.None]: "",
  [RandomItemGenerationCategory.Numbers]: "Numbers",
  [RandomItemGenerationCategory.Letters]: "Letters",
  [RandomItemGenerationCategory.FirstNames]: "First names",
  [RandomItemGenerationCategory.CityNames]: "City names",
  [RandomItemGenerationCategory.CountryNames]: "Country names",
  [RandomItemGenerationCategory.Jobs]: "Jobs",
  [RandomItemGenerationCategory.Fruits]: "Fruits",
  [RandomItemGenerationCategory.Drinks]: "Drinks",
  [RandomItemGenerationCategory.Animals]: "Animals",
  [RandomItemGenerationCategory.WordStartingWithT]: 'English words starting with "t"'
};

